import { BaseItemModelService } from './base-item.model';
import { TemplateLayoutHelper } from '@fi-app/template/template-layout-helper';

export interface ITemplatePlaceholder {
    class?: string;
    items?: BaseItemModelService[];
    children?: ITemplatePlaceholder[];
}

export class TemplateLayoutModel {
    placeholders: ITemplatePlaceholder[] = [];
    templateLayoutHelper: TemplateLayoutHelper;
    selectedItem = null;
    selectedColumn;

    toJSON() {
        let result: { [prop: string]: any } = {};
        for (let x in this) {
            if (x !== 'templateLayoutHelper') result[x] = this[x];
        }
        return result;
    }
}

export class TemplateLayoutAModel extends TemplateLayoutModel {
    constructor() {
        super();

        this.placeholders = [
            {
                items: [],
            },
            {
                items: [],
            },
            {
                items: [],
            },
            {
                items: [],
            },
        ];
    }
}

export class TemplateLayoutBModel extends TemplateLayoutModel {
    constructor() {
        super();

        this.placeholders = [
            {
                items: [],
            },
            {
                class: 'col-2-half',
                children: [
                    {
                        items: [],
                    },
                    {
                        items: [],
                    },
                ],
            },
            {
                items: [],
            },
            {
                items: [],
            },
        ];
    }
}

export class TemplateLayoutCModel extends TemplateLayoutModel {
    constructor() {
        super();

        this.placeholders = [
            {
                items: [],
            },
            {
                class: 'col-2-side',
                children: [
                    {
                        items: [],
                    },
                    {
                        items: [],
                    },
                ],
            },
        ];
    }
}

export class TemplateLayoutDModel extends TemplateLayoutModel {
    constructor() {
        super();

        this.placeholders = [
            {
                class: 'col-2-half',
                children: [
                    {
                        items: [],
                    },
                    {
                        items: [],
                    },
                ],
            },
        ];
    }
}

export class TemplateLayoutEModel extends TemplateLayoutModel {
    constructor() {
        super();

        this.placeholders = [
            {
                items: [],
            },
            {
                class: 'col-2-half',
                children: [
                    {
                        items: [],
                    },
                    {
                        items: [],
                    },
                ],
            },
            {
                items: [],
            },
            {
                class: 'col-2-half',
                children: [
                    {
                        items: [],
                    },
                    {
                        items: [],
                    },
                ],
            },
        ];
    }
}

export class TemplateLayoutFModel extends TemplateLayoutModel {
    constructor() {
        super();

        this.placeholders = [
            {
                class: 'col-3-parts',
                children: [
                    {
                        items: [],
                    },
                    {
                        items: [],
                    },
                    {
                        items: [],
                    },
                ],
            },
        ];
    }
}

export class TemplateLayoutGModel extends TemplateLayoutModel {
    constructor() {
        super();

        this.placeholders = [
            {
                class: 'col-2-parts-left-main',
                children: [
                    {
                        items: [],
                    },
                    {
                        items: [],
                    },
                ],
            },
        ];
    }
}

export class TemplateLayoutHModel extends TemplateLayoutModel {
    constructor() {
        super();

        this.placeholders = [
            {
                class: 'col-2-parts-right-main',
                children: [
                    {
                        items: [],
                    },
                    {
                        items: [],
                    },
                ],
            },
        ];
    }
}

export class TemplateLayoutIModel extends TemplateLayoutModel {
    constructor() {
        super();

        this.placeholders = [
            {
                items: [],
            },
            {
                class: 'col-2-parts-equal',
                children: [
                    {
                        items: [],
                    },
                    {
                        items: [],
                    },
                ],
            },
        ];
    }
}

export class TemplateLayoutJModel extends TemplateLayoutModel {
    constructor() {
        super();

        this.placeholders = [
            {
                items: [],
            },
            {
                class: 'col-2-parts-right-main',
                children: [
                    {
                        items: [],
                    },
                    {
                        items: [],
                    },
                ],
            },
        ];
    }
}

export class TemplateLayoutKModel extends TemplateLayoutModel {
    constructor() {
        super();

        this.placeholders = [
            {
                class: 'col-2-parts-equal',
                children: [
                    {
                        items: [],
                    },
                    {
                        items: [],
                    },
                ],
            },
            {
                items: [],
            },
        ];
    }
}

export class TemplateLayoutLModel extends TemplateLayoutModel {
    constructor() {
        super();

        this.placeholders = [
            {
                class: 'col-2-parts-right-main',
                children: [
                    {
                        items: [],
                    },
                    {
                        items: [],
                    },
                ],
            },
            {
                items: [],
            },
        ];
    }
}

export class TemplateLayoutMModel extends TemplateLayoutModel {
    constructor() {
        super();

        this.placeholders = [
            {
                class: 'col-2-parts-left-main',
                children: [
                    {
                        items: [],
                    },
                    {
                        items: [],
                    },
                ],
            },
            {
                items: [],
            },
        ];
    }
}

export class TemplateLayoutNModel extends TemplateLayoutModel {
    constructor() {
        super();

        this.placeholders = [
            {
                items: [],
            },
            {
                class: 'col-3-parts',
                children: [
                    {
                        items: [],
                    },
                    {
                        items: [],
                    },
                    {
                        items: [],
                    },
                ],
            },
        ];
    }
}
